import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CalculationRunOptions } from '../../../../../../../common/src/options/calculations/calculation-run.options';
import { CalculationResponse } from '../../../../../../../common/dist/angular/responses/calculation.response';

@Injectable({
  providedIn: 'root',
})
export class CalculationLifecycleManager {
  public calculationStartedRunning = new Subject<CalculationRunOptions>();
  public calculationCompleted = new Subject<CalculationResponse>();
}
